import { appConfig } from '../../../../../config/customization';

export default {
  mobileAvatar: {
    height: 60,
    width: 'auto',
    display: appConfig.disabledMobileAvatarEnergyAdvisor && 'none'
  },
  mobileTopbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 15px',
    height: 50,
    borderBottom: `1px solid ${appConfig.colors.bordersGray}`
  },
  list: {
    marginTop: 0,
    padding: '10px 15px'
  }
};
